import React from 'react';
import { NavLink } from 'react-router-dom';

interface Props {
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const NotAvailable: React.FC<Props> = ({ onClick }) => {
	return (
		<div className="center-center-content">
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>We’re sorry. In-home services are not available for your location at this time.</p>
					<p>
						Would you like to schedule a
						{' '}
						<NavLink to="/our-services/telehospice" className="inline-link">
							telehospice
						</NavLink>
						{' '}
						appointment with a veterinarian to discuss your pet’s quality of life?
					</p>
				</div>
				<button onClick={onClick} className="btn btn-md btn-primary link">
					Request a Telehospice Appointment
				</button>
				<div className="text-small">
					If you are in need of immediate in home veterinary care, please see
					{' '}
					<a href="https://www.vetangel.com/ " target="_blank" rel="noopener noreferrer">
						directory
					</a>
					{' '}
					for other providers.
				</div>
			</div>
		</div>
	);
};

export default NotAvailable;
